<template>
  <div class="project-user">
    <base-table
      ref="table"
      url="/user/findByProject"
      :toolbar="toolbar"
      :columns="columns"
      :init-search="false"
      stripe
      border
    ></base-table>
    <base-dialog
      :title="dialog.title"
      v-model="dialog.show"
      @ok="saveDialogData"
      :ok-loading="dialog.okLoading"
    >
      <base-form
        :init-value="false"
        v-model="dialog.formData"
        ref="dialogForm"
        :rules="dialog.rules"
        :form-items="dialog.formItems"
      ></base-form>
    </base-dialog>
    <!-- <base-dialog
      title="设置特殊权限"
      v-model="extraResDialog.show"
      @ok="saveExtraResDialogData"
    >
      <project-resource-tree
        :projectid="project.id"
        ref="extraResTree"
        style="height: 500px; overflow: auto"
        :props="{
          disabled: calcExtraResTreeDisabled
        }"
      ></project-resource-tree>
    </base-dialog> -->
    <extra-res-dialog
      ref="extraResDialog"
      title="设置特殊权限"
      v-model="extraResDialog.show"
      :projectid="project.id"
      :uid="extraResDialog.uid"
      :domain="project.domain"
      :ok-loading="extraResDialog.okLoading"
      @ok="saveExtraResDialogData"
    >
    </extra-res-dialog>
    <form v-show="false" ref="importForm">
      <input
        type="file"
        ref="importFile"
        accept=".xlsx"
        @change="onImportUserFileChange"
      />
    </form>
  </div>
</template>
<script>
// import emitter from 'element-ui/src/mixins/emitter'
import { exportXlsxFile, readXlsxFileToJson } from '../plugins/exceljs'
export default {
  name: 'project-user',
  // mixins: [emitter],
  props: {
    active: Boolean, //组件是否激活
    project: Object //项目对象
  },
  data() {
    var roleOptions = []
    return {
      exportUserLoading: false,
      importUserLoading: false,
      toolbar: {
        formItems: [
          {
            label: '账号',
            prop: 'id',
            field: 'a.uid',
            cp: this.$ComparePatterns.Matchs,
            bind: { style: 'width: 120px' }
          },
          {
            label: '姓名',
            prop: 'nick_name',
            field: 'u.nick_name',
            cp: this.$ComparePatterns.Matchs,
            bind: { style: 'width: 120px' }
          }
        ],
        query: {
          project: this.project.id,
          SortFields: JSON.stringify([{ Field: 'a.uid', Order: 1 }])
        }
      },
      columns: [
        { bind: { label: '账号', prop: 'uid', width: 120 } },
        { bind: { label: '姓名', prop: 'nick_name', width: 120 } },
        {
          bind: { label: '状态', prop: 'disabled', width: 100 },
          default: {
            component: 'user-state'
          }
        },
        {
          bind: { label: '所属角色', prop: 'role_names' },
          default: {
            component: 'cell-render-vnode',
            bind: {
              vnode: (scope, defaultValue) => {
                if (!defaultValue) {
                  return null
                }
                const roleNames = defaultValue.split(',')
                return (
                  <div class='role-tag-wrap'>
                    {roleNames.map((roleName) => {
                      return <el-tag size='mini'>{roleName}</el-tag>
                    })}
                  </div>
                )
              }
            }
          }
        },
        // {
        //   bind: { label: '特殊权限', prop: 'special_permissions', width: 80 }
        // },
        {
          bind: { label: '操作', prop: 'Name', width: 230 },
          header: {
            component: 'cell-render-vnode',
            bind: {
              vnode: (scope) => {
                return (
                  <div>
                    <el-button
                      type='primary'
                      size='mini'
                      onclick={() => {
                        this.beginAdd()
                      }}
                    >
                      新增
                    </el-button>
                    <el-button
                      size='mini'
                      loading={this.importUserLoading}
                      onclick={() => {
                        this.beginImportUser()
                      }}
                    >
                      导入
                    </el-button>
                    <el-button
                      size='mini'
                      loading={this.exportUserLoading}
                      onclick={() => {
                        this.beginExportUser()
                      }}
                    >
                      导出
                    </el-button>
                  </div>
                )
              }
            }
          },
          default: {
            component: 'cell-render-vnode',
            bind: {
              vnode: (scope) => {
                return (
                  <div>
                    <el-button
                      type='text'
                      icon='el-icon-edit'
                      size='mini'
                      onclick={() => {
                        this.beginEdit(scope.row)
                      }}
                    >
                      修改
                    </el-button>
                    <el-button
                      type='text'
                      icon='el-icon-setting'
                      size='mini'
                      onclick={() => {
                        this.beginEditExtraRes(scope.row)
                      }}
                    >
                      特殊权限
                    </el-button>
                    <el-button
                      type='text'
                      icon='el-icon-delete'
                      size='mini'
                      onclick={() => {
                        this.beginDelete(scope.row)
                      }}
                    >
                      删除
                    </el-button>
                  </div>
                )
              }
            }
          }
        }
      ],
      roleOptions,
      dialog: {
        show: false,
        okLoading: false,
        title: '新增',
        formData: {
          nick_name: '',
          uid: '',
          role_ids: []
        },
        rules: {
          nick_name: [
            {
              required: true,
              message: '请选择用户',
              trigger: ['blur', 'change']
            }
          ],
          uid: [
            {
              required: true,
              message: '请选择用户',
              trigger: ['blur', 'change']
            }
          ],
          role_ids: [
            {
              required: true,
              message: '请选择角色',
              trigger: ['blur', 'change']
            }
          ]
        },
        formItems: [
          {
            label: '姓名',
            prop: 'nick_name',
            component: 'form-select-user',
            bind: {
              operLabel: '选择'
            }
          },
          {
            label: '账号',
            prop: 'uid',
            component: 'form-text',
            bind: {
              formatter: (formValue, value) => {
                console.log('formatter', value)
                // this.dispatch('ElFormItem', 'el.form.change', value)
                if (value && this.$refs.dialogForm) {
                  this.$refs.dialogForm.clearValidate('uid')
                }
                return value
              }
            }
          },
          {
            label: '角色',
            prop: 'role_ids',
            component: 'form-select-role',
            bind: {
              multiple: true,
              projectid: this.project.id
            }
          }
        ]
      },
      extraResDialog: {
        show: false,
        okLoading: false,
        uid: '',
        userResIds: [],
        extraResIds: []
      }
    }
  },
  methods: {
    refreshUser() {
      clearTimeout(window.refreshUserTimeout)
      window.refreshUserTimeout = setTimeout(() => {
        this.$refs.table.refreshData()
      }, 100)
    },
    beginAdd() {
      this.dialog.show = true
      this.dialog.title = '新增'
      this.dialog.formData.nick_name = ''
      this.dialog.formData.uid = ''
      this.dialog.formData.role_ids = []
    },
    beginEdit(row) {
      this.dialog.show = true
      this.dialog.title = '修改'
      this.dialog.formData.nick_name = row.nick_name
      this.dialog.formData.uid = row.uid
      this.dialog.formData.role_ids = (row.role_ids || '').split(',')
    },
    beginDelete(row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$postObj('/user/clearUserRoles', {
            domain: this.project.domain,
            project: this.project.id,
            uid: row.uid
          })
            .then((resp) => {
              if (resp.data.code == 0) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                })
                this.refreshUser()
              } else {
                this.$message(`删除失败:${resp.data.msg}`)
              }
            })
            .catch((err) => {
              console.error('删除发生异常=>', err)
              this.$message(`删除发生异常:${err}`)
            })
        })
        .catch(() => {
          console.log('删除取消')
        })
    },
    saveDialogData() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          this.dialog.okLoading = true
          this.$postObj('/user/setUserRoles', {
            domain: this.project.domain,
            project: this.project.id,
            uid: this.dialog.formData.uid,
            role_ids: this.dialog.formData.role_ids
          })
            .then((resp) => {
              this.dialog.okLoading = false
              if (resp.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.refreshUser()
                this.dialog.show = false
              } else {
                this.$message(`保存失败:${resp.data.msg}`)
              }
            })
            .catch((err) => {
              this.dialog.okLoading = false
              console.error('保存发生异常=>', err)
              this.$message(`保存发生异常:${err}`)
            })
        } else {
          this.$message('请填写完整信息')
        }
      })
    },
    calcExtraResTreeDisabled(data, node) {
      if (this.extraResDialog.userResIds.includes(data.id)) {
        return true
      }
      return false
    },
    beginEditExtraRes(row) {
      this.extraResDialog.uid = row.uid
      this.extraResDialog.show = true
      this.$nextTick(() => {
        if (this.$refs.extraResDialog) {
          this.$refs.extraResDialog.refreshProjectResource()
        }
      })
    },
    saveExtraResDialogData() {
      var resIds = this.$refs.extraResDialog.getCheckedKeys()
      console.log(resIds)
      this.extraResDialog.okLoading = true
      this.$postObj('/user/setUserExtraRes', {
        domain: this.project.domain,
        project: this.project.id,
        uid: this.extraResDialog.uid,
        res_ids: resIds
      })
        .then((resp) => {
          this.extraResDialog.okLoading = false
          if (resp.data.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.extraResDialog.show = false
          } else {
            this.$message(`保存失败:${resp.data.msg}`)
          }
        })
        .catch((err) => {
          this.extraResDialog.okLoading = false
          console.error('保存发生异常=>', err)
          this.$message(`保存发生异常:${err}`)
        })
    },
    beginExportUser() {
      this.exportUserLoading = true
      this.$post('/user/findByProject', {
        project: this.project.id,
        PageIndex: 1,
        PageSize: 10000,
        SortFields: JSON.stringify([{ Field: 'a.uid', Order: 1 }])
      })
        .then((resp) => {
          this.exportUserLoading = false
          if (resp.data.code == 0) {
            this.endExportUser(resp.data.data.Data || [])
          } else {
            this.$message(`导出失败:${resp.data.msg}`)
          }
        })
        .catch((err) => {
          this.exportUserLoading = false
          console.error('导出发生异常=>', err)
          this.$message(`导出发生异常:${err}`)
        })
    },
    endExportUser(exportData) {
      console.log('exportData', exportData)
      if (exportData.length == 0) {
        this.$message('没有数据可导出')
        return
      }
      exportXlsxFile(
        `${this.project.name || ''}${
          this.project.name ? '_' : ''
        }角色账号_${new Date().getTime()}.xlsx`,
        [
          { header: '账号', key: 'uid', width: 15 },
          { header: '姓名', key: 'nick_name', width: 15 },
          { header: '所属角色', key: 'role_names', width: 30 }
        ],
        {},
        exportData
      )
    },
    beginImportUser(row) {
      this.$refs.importFile.click()
    },
    async onImportUserFileChange(event) {
      var file = event.target.files[0]
      if (file) {
        console.log('file', file)
        var ext = file.name.split('.').pop()
        if (ext != 'xlsx') {
          this.$message('请上传xlsx文件')
          return
        }
        try {
          var data = await readXlsxFileToJson(file, {
            keyMap: {
              账号: 'uid',
              姓名: 'nick_name',
              所属角色: 'role_names'
            }
          })
          console.log('readXlsxFileToJson=>data', data)
          if (data.length == 0) {
            this.$message('没有数据可导入')
            return
          }
          if (data.some((item) => !item.uid && !item.nick_name)) {
            this.$message('账号/姓名不能同时为空，请检查文件内容')
            return
          }
          if (data.some((item) => !item.role_names)) {
            this.$message('所属角色不能为空，请检查文件内容')
            return
          }
          this.endImportUser(data)
        } catch (error) {
          console.error('读取xlsx文件发生异常=>', error)
          this.$message(`读取${file.name}文件失败，请检查文件内容`)
        } finally {
          this.$refs.importForm.reset()
        }
      }
    },
    endImportUser(data) {
      this.importUserLoading = true
      this.$postObj('/user/importUserRoles', {
        domain: this.project.domain,
        project: this.project.id,
        userRoles: data.map((item) => {
          return {
            uid: item.uid,
            nick_name: item.nick_name,
            role_names: item.role_names
              .split(/[,;，；、\|]+/)
              .filter((item) => item.trim())
          }
        })
      })
        .then((resp) => {
          this.importUserLoading = false
          if (resp.data.code == 0) {
            this.$message({
              message: '导入成功',
              type: 'success'
            })
            this.refreshUser()
          } else {
            this.$message(`导入失败:${resp.data.msg}`)
          }
        })
        .catch((err) => {
          this.importUserLoading = false
          console.error('导入发生异常=>', err)
          this.$message(`导入发生异常:${err}`)
        })
    }
  },
  watch: {
    active: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refreshUser()
        }
      }
    }
  }
}
</script>
<style lang="less">
.project-user {
  height: 750px;
  .role-tag-wrap {
    .el-tag + .el-tag {
      margin-left: 6px;
    }
  }
}
</style>
